import React, { useEffect, useRef } from 'react';
import './IconAnimation.css'

const IconStrikeAnimation = () => {
  const iconsContainerRef = useRef();
  const animationTimeoutRef = useRef();
  const isAnimatingRef = useRef(true);
  const speedRef = useRef(3);
  const iconsRef = useRef([]);
  const movingIndexRef = useRef(0);

  const iconSize = 45;
  const circleSize = 40;
  
  const iconShapes = [
    '/images/icons/de.png',
    '/images/icons/fr.png',
    '/images/icons/es.png',
    '/images/icons/ru.png',
    '/images/icons/pt.png'
  ];

  // 初始化图标
  const initIcons = () => {
    if (!iconsContainerRef.current) return;
    
    iconsContainerRef.current.innerHTML = '';
    iconsRef.current = [];
    
    for (let i = 0; i < 5; i++) {
      const icon = document.createElement('div');
      icon.className = 'loading-animation-icon';
      
      icon.style.left = `${i * iconSize}px`;
      
      // 创建img
      const img = document.createElement('img');
      img.src = iconShapes[i];
      icon.appendChild(img);

      iconsContainerRef.current.appendChild(icon);
      iconsRef.current.push(icon);
    }
    
    // 设置第一个图标为运动图标
    movingIndexRef.current = 0;
    iconsRef.current[movingIndexRef.current].classList.add('loading-animation-moving');
  };

  const startAnimation = () => {
    if (!isAnimatingRef.current) return;
    
    const icons = iconsRef.current;
    const movingIndex = movingIndexRef.current;
    const speed = speedRef.current;
    
    if (!icons || !icons[movingIndex]) return;

    // 清除之前的定时器
    if (animationTimeoutRef.current) {
      clearTimeout(animationTimeoutRef.current);
    }

    // 第一步：上移并旋转90度
    icons[movingIndex].style.transition = `all ${0.8/speed}s ease`;
    icons[movingIndex].style.transform = `translateY(-${circleSize}px) rotate(90deg)`;
    
    animationTimeoutRef.current = setTimeout(() => {
      // 右移到第二个图标上方
      icons[movingIndex].style.transition = `all ${0.8/speed}s ease`;
      icons[movingIndex].style.transform = `translateX(${iconSize}px) translateY(-${circleSize}px) rotate(180deg)`;
      
      animationTimeoutRef.current = setTimeout(() => {
        // 击打第二个图标
        icons[1].classList.add('loading-animation-hit-effect');
        
        animationTimeoutRef.current = setTimeout(() => {
          icons[1].classList.remove('loading-animation-hit-effect');
          
          // 第二步：移动到第三个图标上方
          icons[movingIndex].style.transition = `all ${0.8/speed}s ease`;
          icons[movingIndex].style.transform = `translateX(${iconSize * 2}px) translateY(-${circleSize}px) rotate(270deg)`;
          
          animationTimeoutRef.current = setTimeout(() => {
            // 击打第三个图标
            icons[2].classList.add('loading-animation-hit-effect');
            
            animationTimeoutRef.current = setTimeout(() => {
              icons[2].classList.remove('loading-animation-hit-effect');
              
              // 第三步：移动到第四个图标上方
              icons[movingIndex].style.transition = `all ${0.8/speed}s ease`;
              icons[movingIndex].style.transform = `translateX(${iconSize * 3}px) translateY(-${circleSize}px) rotate(360deg)`;
              
              animationTimeoutRef.current = setTimeout(() => {
                // 击打第四个图标
                icons[3].classList.add('loading-animation-hit-effect');
                
                animationTimeoutRef.current = setTimeout(() => {
                  icons[3].classList.remove('loading-animation-hit-effect');
                  
                  // 第四步：移动到第五个图标上方
                  icons[movingIndex].style.transition = `all ${0.8/speed}s ease`;
                  icons[movingIndex].style.transform = `translateX(${iconSize * 4}px) translateY(-${circleSize}px) rotate(450deg)`;
                  
                  animationTimeoutRef.current = setTimeout(() => {
                    // 击打第五个图标
                    icons[4].classList.add('loading-animation-hit-effect');
                    
                    animationTimeoutRef.current = setTimeout(() => {
                      icons[4].classList.remove('loading-animation-hit-effect');
                      
                      // 第五步：移动到第五个图标右侧
                      icons[movingIndex].style.transition = `all ${0.8/speed}s ease`;
                      icons[movingIndex].style.transform = `translateX(${iconSize * 5}px) translateY(-${circleSize}px) rotate(540deg)`;
                      
                      animationTimeoutRef.current = setTimeout(() => {
                        // 下移击打右侧
                        icons[movingIndex].style.transition = `all ${0.4/speed}s ease`;
                        icons[movingIndex].style.transform = `translateX(${iconSize * 5}px) translateY(0) rotate(630deg)`;
                        
                        animationTimeoutRef.current = setTimeout(() => {
                          // 移除当前运动图标的高亮
                          icons[movingIndex].classList.remove('loading-animation-moving');
                          
                          // 保存当前的运动图标（第一个）
                          const movingIcon = icons[movingIndex];
                          
                          // 所有图标向左移动一个位置（包括运动图标）
                          for (let i = 0; i < 5; i++) {
                            icons[i].style.transition = `all ${0.8/speed}s ease`;
                            if (i === movingIndex) {
                              // 运动图标左移到第五个位置
                              icons[i].style.transform = ``;
                              icons[i].style.left = `${4 * iconSize}px`;
                            } else {
                              // 其他图标左移
                              icons[i].style.left = `${(i-1) * iconSize}px`;
                            }
                          }
                          
                          // 重新排列图标数组
                          const newIcons = [];
                          for (let i = 1; i < 5; i++) {
                            newIcons.push(icons[i]);
                          }
                          newIcons.push(movingIcon);
                          
                          // 更新图标数组
                          iconsRef.current = newIcons;
                          
                          // 设置新的运动图标（第一个）
                          movingIndexRef.current = 0;
                          iconsRef.current[movingIndexRef.current].classList.add('loading-animation-moving');
                          
                          animationTimeoutRef.current = setTimeout(() => {
                            // 重新开始动画
                            if (isAnimatingRef.current) {
                              startAnimation();
                            }
                          }, 800/speed);
                        }, 400/speed);
                      }, 800/speed);
                    }, 300/speed);
                  }, 800/speed);
                }, 300/speed);
              }, 800/speed);
            }, 300/speed);
          }, 800/speed);
        }, 300/speed);
      }, 800/speed);
    }, 800/speed);
  };

  useEffect(() => {

    initIcons();
    
    // 延迟开始动画以确保从视觉上是从第一个元素从底部开始运动的
    const timer = setTimeout(() => {
      startAnimation();
    }, 300);

    return () => {
      clearTimeout(timer);
      if (animationTimeoutRef.current) {
        clearTimeout(animationTimeoutRef.current);
      }
      isAnimatingRef.current = false;
    };
  }, []);

  return (
    <div className="loading-animation-box">
      <div className="loading-animation-icons-container" ref={iconsContainerRef}>
        {/* 图标将通过JavaScript动态添加 */}
      </div>
    </div>
  );
};

export default IconStrikeAnimation;